import { Center } from "@chakra-ui/react";
import V2Redirect from "guards/V2Redirect";
import Header from "components/Header";
import Layout from "components/Layout";
import NotFoundMessage from "components/NotFoundMessage";
import WalletErrors from "components/WalletErrors";
import NftPage from "pages/NftPage";
import NftsPage from "pages/NftsPage";
import StorePage from "pages/StorePage";
import WardrobePage from "pages/WardrobePage";
import { Fragment, useMemo } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import V2ExistsGuard from "guards/V2ExistsGuard";
import { featureFlags } from "config";

const ConnectedPage = () => {
  const nftRoutes = useMemo(() => {
    const routes = [
      {
        path: "/nfts",
        component: NftPage,
      },
    ];

    if (featureFlags.traitsSwapping) {
      routes.push(
        {
          path: "/store",
          component: StorePage,
        },
        {
          path: "/wardrobe",
          component: WardrobePage,
        }
      );
    }

    return routes;
  }, []);

  return (
    <Layout>
      <Header />

      <Routes>
        <Route path="/" element={<Navigate to="/nfts" replace />} />

        <Route path="/nfts" element={<NftsPage />} />

        {nftRoutes.map(({ path, component: Component }) => (
          <Fragment key={path}>
            <Route path={path} element={<V2Redirect basePath={path} />} />
            <Route
              path={`${path}/:tokenId`}
              element={
                <V2ExistsGuard
                  yeyElement={<Component />}
                  neyElement={
                    <Center pt="12" pb="16">
                      <NotFoundMessage />
                    </Center>
                  }
                />
              }
            />
          </Fragment>
        ))}

        <Route
          path="*"
          element={
            <Center pt="12" pb="16">
              <NotFoundMessage />
            </Center>
          }
        />
      </Routes>

      <WalletErrors />
    </Layout>
  );
};

export default ConnectedPage;
